import { BioSampleContainerQuery, BioSampleKitCode } from '@csp/csp-common-hbs-model';
import { Page } from '@csp/dmdp-api-common-dto';
import { BioSamplingContainerSortFieldsV1, BioSamplingContainerQuerySortOrderV1 } from '@csp/dmdp-api-hbs-supply-dto';

const toContainersQuery = ({ kitCode }: { kitCode: BioSampleKitCode }): BioSampleContainerQuery => ({
  pageSize: Page.maxLimit,
  criteria: {
    sampleContainerRefs: [{ kitCode }],
  },
  sort: [
    {
      field: BioSamplingContainerSortFieldsV1.CONTAINER_NUMBER,
      order: BioSamplingContainerQuerySortOrderV1.ASC,
    },
  ],
});

export const BioSampleKitItemQueryMapper = {
  toContainersQuery,
};
